import PricingCardsWithQuiz from 'molecules/PricingCardsWithQuiz/PricingCardsWithQuiz';
import React, { useState } from 'react';
import { usePricingCardsWithPro } from 'src/hooks/usePricingCards';

const PricingDescription = (): JSX.Element => {
  const [activePriceMode, setActivePriceMode] = useState<'monthly' | 'annual'>('annual');
  const pricingItems = usePricingCardsWithPro(activePriceMode);

  return (
    <PricingCardsWithQuiz
      pricingItems={pricingItems}
      activePriceMode={activePriceMode}
      setActivePriceMode={setActivePriceMode}
      priceBlockMinHeight={307}
    />
  );
};

export default PricingDescription;
